<script setup lang="ts">
    import type { Company } from '@/types';
    import {
        Dialog,
        DialogContent,
        DialogBody,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import { CircleDollarSign } from 'lucide-vue-next';
    import { formatCurrency } from '@/utils/helpers';
    import CustomerInvoicesTable from './CustomerInvoicesTable.vue';

    const { t } = useI18n();

    const props = defineProps<{
        company: Company;
    }>();
</script>

<template>
    <Dialog>
        <DialogTrigger as-child>
            <button
                class="flex w-full shrink-0 cursor-pointer items-center gap-2 md:max-w-[200px] 2xl:shrink"
            >
                <CircleDollarSign class="text-destructive size-6 shrink-0" />
                <div class="flex flex-col">
                    <span class="text-left text-lg leading-[1.2] font-medium">{{
                        company.services?.fixed_price
                            ? formatCurrency(props.company.services.fixed_price)
                            : 'N/A'
                    }}</span>
                    <span class="text-muted-foreground text-left text-[10px] leading-none">
                        {{
                            t(
                                `dashboards.customer_stats.price_frequency.${props.company.services?.price_frequency}`,
                            )
                        }}
                    </span>
                </div>
            </button>
        </DialogTrigger>
        <DialogContent class="sm:max-w-3xl">
            <DialogHeader>
                <DialogTitle>{{ t('dashboards.invoices.title') }}</DialogTitle>
            </DialogHeader>

            <DialogBody>
                <CustomerInvoicesTable :company="props.company" />
            </DialogBody>
        </DialogContent>
    </Dialog>
</template>
